export default __webpack_public_path__ + "static/media/1755.77f59c9a.png";